import { useEffect, useState } from 'react';
import { storage } from '../../utils/local-storage-service';
import Icon from '../icon';
import styles from './news-banner.module.scss';

interface Props {
  id: string;
  content: string;
  expiry: Date;
  onVisibilityChange?: (visible: boolean) => void;
}

export default function NewsBanner({
  id,
  content,
  expiry,
  onVisibilityChange
}: Props) {
  const todayMidnight = new Date(new Date().setHours(0, 0, 0, 0));
  const expiryMidnight = new Date(new Date(expiry).setHours(0, 0, 0, 0));
  const [isVisible, setIsVisible] = useState(false);

  const dismiss = () => {
    setIsVisible(false);
    onVisibilityChange && onVisibilityChange(false);
    storage.set(`news-banner-${id}`, true);
  };

  useEffect(() => {
    const visible =
      !storage.get<boolean>(`news-banner-${id}`) &&
      todayMidnight <= expiryMidnight;
    setIsVisible(visible);
    onVisibilityChange && onVisibilityChange(visible);
  }, []);

  return (
    <>
      {isVisible && (
        <div className={styles.newsBanner}>
          <div className={`centered ${styles.wrapper}`}>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <span
              className={styles.dismissButton}
              role="button"
              aria-label="Bezár"
              onClick={dismiss}
            >
              <Icon name="x" aria-hidden="true" />
            </span>
          </div>
        </div>
      )}
    </>
  );
}
